export const types = {
  POLYGON: 'polygon',
  CIRCLE: 'circle',
  SAUSAGE: 'sausage',
}